export var CLIENT_GEN_OTP = "CLIENT_GEN_OTP";
export var CLIENT_GEN_OTP_ERROR = "CLIENT_GEN_OTP_ERROR";
export var CLIENT_GEN_OTP_HIDE_ERROR = "CLIENT_GEN_OTP_HIDE_ERROR";
export var CLIENT_GEN_OTP_START_LOADER = "CLIENT_GEN_OTP_START_LOADER";
export var CLIENT_GEN_OTP_STOP_LOADER = "CLIENT_GEN_OTP_STOP_LOADER";
